// Language options for video language dropdown
export const LANGUAGES = [
  { "code": "en", "name": "English" },
  { "code": "ca", "name": "Català" },
  { "code": "de", "name": "Deutsch" },
  { "code": "fr", "name": "Français" },
  { "code": "it", "name": "Italiano" },
  { "code": "ja", "name": "日本語" },
  { "code": "kk", "name": "Қазақша" },
  { "code": "ko", "name": "한국어" },
  { "code": "ky", "name": "Кыргызча" },
  { "code": "lv", "name": "Latviešu" },
  { "code": "mn", "name": "Монгол" },
  { "code": "pt", "name": "Português" },
  { "code": "ro", "name": "Română" },
  { "code": "ru", "name": "Русский" },
  { "code": "es", "name": "Español" },
  { "code": "uk", "name": "Українська" },
  { "code": "uz", "name": "O'zbekcha" },
  { "code": "zh", "name": "中文" }
];

